module.exports = __webpack_public_path__ + "static/media/character.f5e06c7d.svg";